/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
// import * as types from '@/lib/definition/types'
import moment from "moment-timezone";
moment.locale('ja')

export interface MemberTagState {
  [key: string]: any;
}

const memberTag = defineModule({
  state: (): MemberTagState => {
    return {
    }
  },
  getters: {
  },
  mutations: {
    SET_VALUE(state, param: { name: string; value: any }) {
      state[param.name] = param.value
    }
  },
  actions: {
    async add(context, { name, description, memberTagId, assignedUsers, isPersonal }): Promise<any> {
      const { rootState } = moduleActionContext(context, memberTag)
      if (memberTagId == null) {
        const retval = await Lib.Ajax.getHandleError<any>('/api/membertag/add' + (memberTagId == null ? '' : '/' + memberTagId), "Failed to receive Groups", { name, description, isPersonal }, rootState.Login.accessToken)
        var groups = retval.data.data
        return groups
      } else {
        var assigned = assignedUsers.reduce((prev: any, current: any) => { return (prev == null) ? current : (prev + ',' + current) }, null)
        const retval = await Lib.Ajax.postHandleError<any>('/api/membertag/add' + (memberTagId == null ? '' : '/' + memberTagId), "Failed to receive Groups", { name, description, assignedUsers: assigned }, rootState.Login.accessToken)
        groups = retval.data.data
        return groups
      }
    },
    async delete(context, memberTagId): Promise<any> {
      const { rootState } = moduleActionContext(context, memberTag)
      const retval = await Lib.Ajax.deleteHandleError<any>('/api/membertag/delete/' + memberTagId, "Failed to Delete MemberTag ", {}, rootState.Login.accessToken)
      var groups = retval.data.data
      return groups
    },
    async listAll(context, tagType): Promise<any> {
      const { rootState } = moduleActionContext(context, memberTag)
      const params: { [key: string]: string } = tagType ? { tagType } : {}
      const retval = await Lib.Ajax.getHandleError<any>('/api/membertag/listall', "Failed to receive Groups", params, rootState.Login.accessToken)
      var list = retval.data.data
      return list
    },
  },
  namespaced: true
})

export default memberTag
const loginGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, memberTag)